/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Workout_Open_StartedInputs */

const en_us2_workout_open_started = /** @type {(inputs: Workout_Open_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Started ${i?.when}`)
};

const pt_br2_workout_open_started = /** @type {(inputs: Workout_Open_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Iniciado ${i?.when}`)
};

const es_419_workout_open_started = /** @type {(inputs: Workout_Open_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Empezado ${i?.when}`)
};

const pt_pt2_workout_open_started = /** @type {(inputs: Workout_Open_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Iniciado ${i?.when}`)
};

const fr_fr2_workout_open_started = /** @type {(inputs: Workout_Open_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commencée ${i?.when}`)
};

const de_de2_workout_open_started = /** @type {(inputs: Workout_Open_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gestartet ${i?.when}`)
};

const it_it2_workout_open_started = /** @type {(inputs: Workout_Open_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Iniziato ${i?.when}`)
};

/**
* | output |
* | --- |
* | "Started {when}" |
*
* @param {Workout_Open_StartedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_open_started = /** @type {((inputs: Workout_Open_StartedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Open_StartedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_open_started(inputs)
	if (locale === "es-419") return es_419_workout_open_started(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_open_started(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_open_started(inputs)
	if (locale === "de-DE") return de_de2_workout_open_started(inputs)
	if (locale === "it-IT") return it_it2_workout_open_started(inputs)
	return en_us2_workout_open_started(inputs)
});
export { workout_open_started as "workout.open_started" }